import React from "react";
import ReactDOM from "react-dom";
import AppRouter from "./components/Routes/Router";
import { AuthProvider } from "./context/AuthContext";
import { MobileProvider } from "./context/MobileContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MobileProvider>
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </MobileProvider>
);
